import React from 'react';
import PropTypes from 'prop-types';
import AttachmentPreview from './AttachmentPreview';
import { MediaItemShape } from '../utils/shapes';

const AttachmentPreviewList = ({ mediaItems, files, onDelete }) => (
    <div className="attachment-preview__list">
        {mediaItems.map((mediaItem) => (
            <AttachmentPreview
                key={mediaItem.id}
                mediaItem={mediaItem}
                file={files[mediaItem.id]}
                onDelete={onDelete}
            />
        ))}
    </div>
);

AttachmentPreviewList.propTypes = {
    mediaItems: PropTypes.arrayOf(MediaItemShape),
    files: PropTypes.objectOf(PropTypes.instanceOf(File)),
    onDelete: PropTypes.func,
};
AttachmentPreviewList.defaultProps = {
    mediaItems: [],
    files: {},
    onDelete: null,
};

export default AttachmentPreviewList;



// WEBPACK FOOTER //
// ./src/components/AttachmentPreviewList.js